import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

// Importar estilos necesarios de Swiper
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './PromoModal.css';

const PromoModal = ({ isOpen, onClose, images = [] }) => {
  const promoLink = 'https://www.facebook.com/share/p/14qmBTyr4FU/';
  const closeButtonRef = useRef(null);
  const previousActiveElementRef = useRef(null);

  useEffect(() => {
    if (!isOpen || !images.length) {
      return undefined;
    }

    previousActiveElementRef.current = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
      previousActiveElementRef.current?.focus?.();
    };
  }, [images.length, isOpen, onClose]);

  if (!images.length) {
    return null;
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="promo-modal__backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-label="Promociones"
            className="promo-modal"
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="promo-modal__header">
              <span className="promo-modal__eyebrow">GANA 2 BOLETOS PARA MARCO ANTONIO SOLÍS EN NICARAGUA!</span>
              <button
                ref={closeButtonRef}
                type="button"
                aria-label="Cerrar promociones"
                className="promo-modal__close"
                onClick={onClose}
              >
                <span aria-hidden="true">✕</span>
              </button>
            </div>

            <Swiper
              className="promo-modal__swiper"
              modules={[Navigation, Pagination, Autoplay]}
              navigation
              pagination={{ clickable: true }}
              autoplay={{ delay: 3500, disableOnInteraction: false }}
              loop={images.length > 1}
            >
              {images.map((img, index) => (
                <SwiperSlide className="promo-modal__slide" key={index}>
                  <a
                    className="promo-modal__link"
                    href={promoLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Ver promoción ${index + 1} en Facebook`}
                  >
                    <img
                      src={img}
                      alt={`Anuncio ${index + 1}`}
                      className="promo-modal__image"
                    />
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PromoModal;